import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';

export const SampleDataLabel: React.FC = (): JSX.Element => {
  const { neverAnalyzed } = useSelector((state: RootState) => state.deals);

  const { pathname } = useLocation();

  const isInDetailedView =
    pathname.includes('example') && pathname.includes('threads');

  const attrs = {
    wrapper: {
      className: 'sample-data',
      style: {
        display: `${neverAnalyzed || isInDetailedView ? 'flex' : 'none'}`,
        top: isInDetailedView ? '8px' : '',
      },
    },

    icon: {
      className: 'sample-data-icon',
    },

    text: {
      className: 'sample-data-text',
    },
  };

  const svgIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...attrs.icon}
    >
      <path
        d="M9.99966 1.66797C14.6028 1.66797 18.3343 5.39951 18.3343 10.0026C18.3343 14.6057 14.6028 18.3372 9.99966 18.3372C5.39658 18.3372 1.66504 14.6057 1.66504 10.0026C1.66504 5.39951 5.39658 1.66797 9.99966 1.66797ZM9.99966 2.91797C6.08693 2.91797 2.91504 6.08986 2.91504 10.0026C2.91504 13.9153 6.08693 17.0872 9.99966 17.0872C13.9124 17.0872 17.0843 13.9153 17.0843 10.0026C17.0843 6.08986 13.9124 2.91797 9.99966 2.91797ZM9.99663 8.75179C10.313 8.75158 10.5747 8.98654 10.6163 9.29157L10.622 9.37638L10.625 13.961C10.6253 14.3062 10.3456 14.5862 10.0004 14.5864C9.68403 14.5867 9.42238 14.3517 9.3808 14.0467L9.37504 13.9619L9.37204 9.3772C9.37181 9.03202 9.65145 8.75201 9.99663 8.75179ZM10 5.83698C10.4597 5.83698 10.8323 6.20958 10.8323 6.6692C10.8323 7.12882 10.4597 7.50142 10 7.50142C9.54042 7.50142 9.16782 7.12882 9.16782 6.6692C9.16782 6.20958 9.54042 5.83698 10 5.83698Z"
        fill="white"
      />
    </svg>
  );

  return (
    <div {...attrs.wrapper}>
      {svgIcon}
      <div {...attrs.text}>
        This is sample data. Real data will populate this page as soon you start
        using the platform
      </div>
    </div>
  );
};
